"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Input = _interopRequireDefault(require("./Input"));

var _Label = _interopRequireDefault(require("../Label"));

var _InputContainer = _interopRequireDefault(require("./InputContainer"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var TextInput = function TextInput(_ref) {
  var type = _ref.type,
      id = _ref.id,
      isHiddenLabel = _ref.isHiddenLabel,
      label = _ref.label,
      value = _ref.value,
      errorText = _ref.errorText,
      onChange = _ref.onChange,
      descriptiveTextId = _ref.descriptiveTextId,
      asterisks = _ref.asterisks,
      fsMask = _ref.fsMask,
      otherProps = (0, _objectWithoutProperties2.default)(_ref, ["type", "id", "isHiddenLabel", "label", "value", "errorText", "onChange", "descriptiveTextId", "asterisks", "fsMask"]);

  var inputProps = _objectSpread(_objectSpread({}, otherProps), {}, {
    type: type,
    id: id,
    value: value,
    errorText: errorText,
    onChange: onChange,
    fsMask: fsMask,
    'aria-invalid': errorText ? 'true' : null,
    'aria-describedby': descriptiveTextId
  });

  return /*#__PURE__*/_react.default.createElement(_InputContainer.default, {
    errorText: errorText
  }, /*#__PURE__*/_react.default.createElement(_Label.default, {
    htmlFor: id,
    value: value,
    errorText: errorText,
    isVisuallyHidden: isHiddenLabel,
    asterisks: asterisks
  }, label), /*#__PURE__*/_react.default.createElement(_Input.default, inputProps));
};

TextInput.propTypes = {
  /** The id for the input */
  id: _propTypes.default.string.isRequired,

  /** Ideally, label text is always visible.
   * If necessary, this prop will hide label text from sighted users while still making it available to assistive technology.
   * It will not hide error text.
   */
  isHiddenLabel: _propTypes.default.bool,

  /** The label for the input */
  label: _propTypes.default.string.isRequired,

  /** Value that controls the input */
  value: _propTypes.default.string,

  /** Used for validation */
  errorText: _propTypes.default.string,

  /** Function used to update the value prop */
  onChange: _propTypes.default.func.isRequired,

  /** The type supplied to the input */
  type: _propTypes.default.string,

  /**
   * Links input helper text or footnote text to the input for assistive technology users.
   * Accepts either the id or multiple space-separated ids of the text you want to link to.
   */
  descriptiveTextId: _propTypes.default.string,

  /** The number of asterisks to render in the label */
  asterisks: _propTypes.default.number,

  /** Toggles masking input within FullStory */
  fsMask: _propTypes.default.bool
};
TextInput.defaultProps = {
  value: '',
  errorText: '',
  isHiddenLabel: false,
  type: 'text',
  descriptiveTextId: null,
  asterisks: null,
  fsMask: true
};
var _default = TextInput;
exports.default = _default;